export const decorateEmptyGridValues = (val) => val || '-';

export const setColumnDefaultExtraProps = (props) => {
  const {
    isSortable,
    isDateField,
    shouldFilter,
    filterPlaceholder,
    filterField,
    sortField,
    showFilterMenu,
    hidden,
    strategy,
  } = props;

  return {
    isSortable: isSortable ?? true,
    isDateField: isDateField ?? false,
    shouldFilter: shouldFilter ?? true,
    hidden: hidden ?? false,
    showFilterMenu: showFilterMenu ?? false,
    filterPlaceholder: filterPlaceholder ?? 'Search...',
    filterField,
    sortField,
    strategy,
  };
};